import getEsQuery from '../esParser'
import ElasticsearchAPI from '../../ElasticsearchAPI'

async function age (payload) {
  const jsonQuery = payload['query']

  const esSearch = getEsQuery(jsonQuery, payload)
  esSearch.aggs = getAgeAggregation()
  
  const response = await ElasticsearchAPI.age(esSearch)
  const results = response

  const aggregations = results.aggregations
  const numMonths = aggregations.months.buckets.length
  const data = aggregations.ages.buckets.map(a => ({ age: a.key, value: a.ue.value / numMonths }))
  // return { data }
  return {data: { data }}
}

function getAgeAggregation () {
  return {
    months: {
      date_histogram: {
        field: 'broadcastdate',
        interval: 'month',
        format: 'yyyy-MM'
      }
    },
    ages: {
      terms: {
        field: 'respondent.age'
      },
      aggs: {
        ue: {
          sum: {
            field: 'intabweight'
          }
        }
      }
    }
  }
}

export default age



// WEBPACK FOOTER //
// ./src/app/api/elasticsearch/LAS/age.js